import React, { Children } from "react";
import { Flex, Card, Input, Modal, Select, Pagination, message, Form } from "antd";
import GoodsCard from './card-proxy';
import SwitchShop from '../shop/switch-shop';
import GoodsFilter from './goods-filter';
import ShopCategorySelect from "../category/shop-category-select";
import getCurrentShop, { getCurrentShopId } from "../shop/get-current-shop";
import ProxyList from "./proxy-list";

export default (props) => {
    const [currentShopId, setCurrentShopId] = React.useState(null);
    const [currentShop, setCurrentShop] = React.useState(null);
    const [goodsList, setGoodsList] = React.useState([]);
    const [count, setCount] = React.useState(0);
    const [fromShops, setFromShops] = React.useState([]);
    const [form] = Form.useForm();
    
    React.useEffect(() => {
        const fetchData = async () => {
            const shopId = await getCurrentShopId();
            const shop = await getCurrentShop();
            setCurrentShopId(shopId);
            setCurrentShop(shop);
        };
        
        fetchData();
    }, []);

    React.useEffect(() => {
        if (currentShopId !== null) {
            loadGoodsList();
        }
    }, [currentShopId]);

    const loadGoodsList = async (page  = 1) => {
        getGoodsList(page).then(res => {
            setGoodsList(res.rows);
            setCount(res.count);
        })
    }

    const getGoodsList = async (page = 1) => {
        let response = await fetch(`/api/goods/list?page=${page}`);
        let result = await response.json();

        if(result.success){
            return result.data;
        }

        return [];
    }
    
    return (
        <div>
            <SwitchShop />
            
            <h2 className="admin-page-title">可代理商品列表</h2>
            
            <ProxyList list={goodsList} proxyClick={loadGoodsList} proxyCancel={loadGoodsList} />
            
            <div className="mt-4 flex justify-center">
                <Pagination 
                    defaultCurrent={1} 
                    total={count} 
                    onChange={(page) => loadGoodsList(page)} 
                    simple={{ readOnly: true }} 
                />
            </div>
        </div>
    )
}